import { Address as A } from '@revas/ts-api/src/resources/contact'

export default class Address implements A {
  street = ''
  details = ''
  postalCode = ''
  city = ''
  province = ''
  country = ''
  notes = ''
}
